import { render, staticRenderFns } from "./NotificationStatus.vue?vue&type=template&id=2ff41d81&scoped=true"
import script from "./NotificationStatus.vue?vue&type=script&lang=js"
export * from "./NotificationStatus.vue?vue&type=script&lang=js"
import style0 from "./NotificationStatus.vue?vue&type=style&index=0&id=2ff41d81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff41d81",
  null
  
)

export default component.exports